import { Button, Heading, Icon, Input, Stack, Text, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, useDisclosure, FormControl, AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay } from '@chakra-ui/react'

import { useState, useRef, ChangeEvent, useEffect } from "react";
import { FaPencilAlt, FaSave, FaLock, FaTrash, FaUser } from "react-icons/fa";
import { useSelector } from "react-redux";







export default function UserProfile() {
    const user = useSelector((state: any) => state.user.value);
    const fullName = user?.fullName || user?.full_name || '';
    const [first, ...rest] = fullName.split(' ');
    const [formState, setFormState] = useState({
        firstName: first || '',
        lastName: rest.join(' ') || '',
        email: user?.email || '',
    });

    useEffect(() => {
        const fn = user?.fullName || user?.full_name || '';
        const [f, ...r] = fn.split(' ');
        setFormState({
            firstName: f || '',
            lastName: r.join(' ') || '',
            email: user?.email || '',
        });
    }, [user]);

    const [isDisabled, setisDisabled] = useState<boolean|undefined>(true);

    const { 
        isOpen: isOpenPasswordModal, 
        onOpen: onOpenPasswordModal, 
        onClose: onClosePasswordModal 
    } = useDisclosure()
    
    const { 
        isOpen: isOpenDeleteDialog, 
        onOpen: onOpenDeleteDialog, 
        onClose: onCloseDeleteDialog 
    } = useDisclosure()

    const cancelRef = useRef<HTMLButtonElement>(null)

    const handleInput = (event: ChangeEvent<HTMLInputElement>) => {
        const { name, value } : any = event.target;
        setFormState({...formState,[name]:value});
    }

  return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Modal
                isOpen={isOpenPasswordModal}
                onClose={onClosePasswordModal}
            >
                <ModalOverlay />
                <ModalContent>
                <ModalHeader>Change Password</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <FormControl>
                    <Input placeholder='Current Password' />
                    </FormControl>

                    <FormControl mt={4}>
                    <Input placeholder='New Password' />
                    </FormControl>
                    
                    <FormControl mt={4}>
                    <Input placeholder='Confirm Password' />
                    </FormControl>
                </ModalBody>

                <ModalFooter>
                    <Button onClick={onClosePasswordModal}>Cancel</Button>
                    <Button color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }} onClick={onClosePasswordModal} ml={3}>Save</Button>
                </ModalFooter>
                </ModalContent>
            </Modal>

            <AlertDialog
        isOpen={isOpenDeleteDialog}
        leastDestructiveRef={cancelRef}
        onClose={onCloseDeleteDialog}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Delete Account
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You can't undo this action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onCloseDeleteDialog}>
                Cancel
              </Button>
              <Button colorScheme='red' onClick={onCloseDeleteDialog} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={FaUser}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>User Profile</Heading>
                            <Text fontSize={'sm'}>Manage Your Profile Details.</Text>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack align={{ lg: 'flex-start', xl: 'flex-end' }} justify={'end'} spacing={4}>
                    <Stack direction={'row'}>
                        <Button
                            size={'sm'}
                            leftIcon={isDisabled ? <FaPencilAlt /> : <FaSave/>}
                            onClick={() => setisDisabled(!isDisabled)}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            {isDisabled ? 'Edit Profile' : 'Save'}
                        </Button>
                        
                        <Button
                            size={'sm'}
                            leftIcon={<FaLock/>}
                            onClick={onOpenPasswordModal}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Change Password
                        </Button>
                       
                        <Button
                            size={'sm'}
                            leftIcon={<FaTrash/>}
                            onClick={onOpenDeleteDialog}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Delete Account
                        </Button>
                    </Stack>
                </Stack>
            </Stack>
            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>

            <Stack direction={'row'} w={'full'} justify={'space-between'} spacing={4}>
                <Input type='text' value={formState.firstName} onChange={handleInput} disabled={isDisabled} name={'firstName'} size={'md'} w={'50%'} fontSize={'md'} placeholder='First Name'/>

                <Input type='text' value={formState.lastName} onChange={handleInput} disabled={isDisabled} name={'lastName'} size={'md'} w={'50%'} fontSize={'md'} placeholder='Last Name'/>
            </Stack>

            <Stack direction={'column'} w={'full'} spacing={4}>
                <Input type='email' value={formState.email} onChange={handleInput} disabled={isDisabled} name={'email'} size={'md'} w={'50%'} fontSize={'md'} placeholder='Email'/>
            </Stack>

            </Stack>
        </Stack>
    )
}